import { render, staticRenderFns } from "./Marktanalyse.vue?vue&type=template&id=6f1278c8&"
import script from "./Marktanalyse.vue?vue&type=script&lang=js&"
export * from "./Marktanalyse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports